// src/components/charts/MockShareChip.jsx
//
// Inline chip: "N run mock su M totali". Hidden when there are no mock runs.
// Sourced from two `groupBy=status` calls (mock-excluded vs mock-included).
//
import React from 'react';

const FONT = "'DM Sans', sans-serif";

/**
 * Compute mock count + total from the two stats responses.
 * Returns { mock, total } or null when input is incomplete.
 * Exported for unit testing.
 */
export function computeMockShare(realOnly, withMock) {
  if (!realOnly || !withMock) return null;
  const real  = realOnly.total || 0;
  const total = withMock.total || 0;
  const mock  = Math.max(0, total - real);
  return { mock, total };
}

export default function MockShareChip({ realOnly, withMock }) {
  const share = computeMockShare(realOnly, withMock);
  if (!share || share.mock === 0) return null;
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      padding: '4px 10px', borderRadius: 999,
      background: 'rgba(245,158,11,0.12)', color: '#B45309',
      fontFamily: FONT, fontSize: 11, fontWeight: 600,
      marginBottom: 16,
    }}>
      <span aria-hidden>•</span>
      <span>{share.mock} run mock su {share.total} totali</span>
    </div>
  );
}
